// Helper: file type for preview
export function getFileTypeFromFile(file: File) {
  const ext = file.name.split('.').pop()?.toLowerCase();
  if (ext === 'pdf') return 'pdf';
  if (['jpg', 'jpeg', 'png'].includes(ext || '')) return 'image';
  return 'file';
}

// Clear file selection helper
export function clearFileSelection(
  setSelectedFile: (file: File | null) => void,
  setFilePreviewUrl: (url: string | null) => void,
  setUploadedMediaUrl: (url: string | null) => void,
  setGcsUri: (uri: string | null) => void,
  setUploadProgress: (progress: number) => void,
  setUploading: (uploading: boolean) => void,
  setUploadError: (error: string) => void
) {
  setSelectedFile(null);
  setFilePreviewUrl(null);
  setUploadedMediaUrl(null);
  setGcsUri(null);
  setUploadProgress(0);
  setUploading(false);
  setUploadError('');
} 